import { AutoSave, FormWrapper } from "@dzambalaorg/mui-form";
import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import type { IMarketplaceSupplySearchDto } from "@framework/types";
import { ContractFeatures, ContractStatus, TokenStatus, TokenType } from "@framework/types";
import { SearchMerchantContractsInput, SearchMerchantInput, TemplateInput } from "@framework/shared";
import { Collapse, FormGrid } from "@dzambalaorg/ui-kit";

interface IMarketplaceGradeSearchFormProps {
  onSubmit: (values: IMarketplaceSupplySearchDto) => Promise<any>;
  initialValues: IMarketplaceSupplySearchDto;
  open: boolean;
}

export const MarketplaceGradeSearchForm = (props: IMarketplaceGradeSearchFormProps) => {
  const { onSubmit, initialValues, open } = props;

  const { tokenStatus, tokenType, contractIds, templateIds, attribute, merchantId } = initialValues;
  const fixedValues = { tokenStatus, tokenType, contractIds, templateIds, attribute, merchantId };

  return (
    <FormWrapper
      initialValues={fixedValues}
      onSubmit={onSubmit}
      showButtons={false}
      showPrompt={false}
      testId="GradeSearchForm"
    >
      <Collapse in={open}>
        <FormGrid columns={[3, 2]}>
          <SearchMerchantInput />
          <SelectInput
            name="tokenType"
            options={TokenType}
            disabledOptions={[TokenType.NATIVE, TokenType.ERC20, TokenType.ERC1155]}
          />
          <SelectInput name="tokenStatus" options={TokenStatus} />
          <SearchMerchantContractsInput
            name="contractIds"
            fetchData={{
              contractStatus: [ContractStatus.ACTIVE],
              contractFeatures: [ContractFeatures.DISCRETE],
            }}
            multiple
            withTokenType
          />
          <TemplateInput contractFeatures={[ContractFeatures.DISCRETE]} />
        </FormGrid>
      </Collapse>
      <AutoSave onSubmit={onSubmit} />
    </FormWrapper>
  );
};
